// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard .recent-sales {
  font-size: 14px;
}

.dashboard .recent-sales .table thead {
  background: #f6f6fe !important;
}

.dashboard .recent-sales .table thead th {
  border: 0;
}

.dashboard .recent-sales .dataTable-top {
  padding: 0 0 10px 0;
}

.dashboard .recent-sales .dataTable-bottom {
  padding: 10px 0 0 0;
}

.dashboard .recent-sales .segment {
  padding-left: 50px;
}

.blob {
  background: black;
  border-radius: 50%;
  margin: 10px;
  height: 20px;
  width: 20px;

  box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
  transform: scale(1);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}

.animate-pulse div {
  background-color: lightgrey;
  height: 20px;
  border-radius: 5px;
  margin-bottom: 5px;
}

/*
<div className="d-flex justify-content-center animate-pulse ">
<div className="spinner-border" role="status">
  <span className="visually-hidden">Loading...</span>
</div>
</div>*/
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/Usuarios/usuarios.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,WAAW;;EAEX,oCAAoC;EACpC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE;IACE,sBAAsB;IACtB,sCAAsC;EACxC;;EAEA;IACE,mBAAmB;IACnB,uCAAuC;EACzC;;EAEA;IACE,sBAAsB;IACtB,oCAAoC;EACtC;AACF;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;;;OAKO","sourcesContent":[".dashboard .recent-sales {\n  font-size: 14px;\n}\n\n.dashboard .recent-sales .table thead {\n  background: #f6f6fe !important;\n}\n\n.dashboard .recent-sales .table thead th {\n  border: 0;\n}\n\n.dashboard .recent-sales .dataTable-top {\n  padding: 0 0 10px 0;\n}\n\n.dashboard .recent-sales .dataTable-bottom {\n  padding: 10px 0 0 0;\n}\n\n.dashboard .recent-sales .segment {\n  padding-left: 50px;\n}\n\n.blob {\n  background: black;\n  border-radius: 50%;\n  margin: 10px;\n  height: 20px;\n  width: 20px;\n\n  box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);\n  transform: scale(1);\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);\n  }\n\n  70% {\n    transform: scale(1);\n    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);\n  }\n\n  100% {\n    transform: scale(0.95);\n    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);\n  }\n}\n\n.animate-pulse {\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n@keyframes pulse {\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.animate-pulse div {\n  background-color: lightgrey;\n  height: 20px;\n  border-radius: 5px;\n  margin-bottom: 5px;\n}\n\n/*\n<div className=\"d-flex justify-content-center animate-pulse \">\n<div className=\"spinner-border\" role=\"status\">\n  <span className=\"visually-hidden\">Loading...</span>\n</div>\n</div>*/\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
